import * as PropTypes from 'prop-types'

import {Td, TdInner, TdLink} from './AssetRow.styles'

const AssetRowCell = ({to, children, ...rest}) => (
  <Td {...rest}>
    <TdInner>
      {to && <TdLink to={to} />}
      {children}
    </TdInner>
  </Td>
)

AssetRowCell.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
}
export default AssetRowCell
